import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Option from '../lib/steps_components/options/Option';
import OptionElement from '../lib/steps_components/options/OptionElement';
import Options from '../lib/steps_components/options/Options';
import OptionsStepContainer from '../lib/steps_components/options/OptionsStepContainer';
import values from 'object.values'

class OptionsStep extends Component {

    onOptionClick = ({value, label,trigger}) => {
        const {triggerNextStep} = this.props;
        triggerNextStep({value: value, userAnswer: label,trigger:trigger});
    };

    renderOption = (option) => {
        const {bubbleOptionStyle} = this.props;
        const {value, label,trigger} = option;

        return (
            <Option
                key={value}
                className="rsc-os-option"
            >
                <OptionElement
                    className="rsc-os-option-element"
                    style={bubbleOptionStyle}
                    onClick={() => this.onOptionClick({value, label,trigger})}
                >
                    {label}
                </OptionElement>
            </Option>
        );
    }

    render() {
        const {options} = this.props;
        return (
            <OptionsStepContainer className="rsc-os">
                <Options className="rsc-os-options">
                    {!Object.values ?  values(options).map(this.renderOption) : Object.values(options).map(this.renderOption)}
                </Options>
            </OptionsStepContainer>
        );
    }
}

OptionsStep.propTypes = {
    bubbleOptionStyle: PropTypes.objectOf(PropTypes.any).isRequired,
    // step: PropTypes.objectOf(PropTypes.any).isRequired,
    triggerNextStep: PropTypes.func.isRequired,
};

export default OptionsStep;
